import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from 'react-redux';
import {activateUserModule, deactivateUserModule, editUser, getUserModules} from "../store/actions/usersActions";
import { getLoggedUserId } from "../helpers/helpers";
// import { NavLink } from 'react-router-dom';
import './UserDetailsForm.scss';

import Spinner from "./_common/Spinner";

const selector = state => {
    const { language, modalState, users} = state;
    return {
        t: language.translator,
        modalState: modalState,
        userModules: users.userModules
    }
};

const UserDetailsForm = props => {
    const { user } = props;
    const { t, userModules } = useSelector(selector);
    const dispatch = useDispatch();
    const [firstName, setFirstName] = useState(user.firstName);
    const [lastName, setLastName] = useState(user.lastName);
    const [email, setEmail] = useState(user.email);

    // useEffect(() => {
    //     dispatch(getUserModules(getLoggedUserId()))
    // },[])

    // const handleCheckboxChange = async (module) => {
    //     if (module.moduleActivated) {
    //         await dispatch(deactivateUserModule(getLoggedUserId(), module.moduleType));
    //         await dispatch(getUserModules(getLoggedUserId()))
    //     } else {
    //        await dispatch(activateUserModule(getLoggedUserId(), module.moduleType));
    //         await dispatch(getUserModules(getLoggedUserId()))
    //     }
    //
    // };

    const updateUserProfile = () => {
        const userData = {
            id: getLoggedUserId(),
            firstName,
            lastName,
            fullName: firstName + ' ' + lastName,
            email,
            login: user.login,
            password: user.password,
            iconUrl: user.iconUrl,
            role: user.role
        };

        dispatch(editUser(false, userData));
    };

    if(Object.keys(user).length === 0 && user.constructor === Object) {
        return (
            <div className='page'>
                <Spinner size={300}/>
            </div>
        );
    } else {
        return (
            <div className="userInfo">
                <div className='userInfoItem'>
                    <div className='userInfoLabel'>
                        {t.gettext('First Name')}
                    </div>
                    <input
                        className='userInfoDetail'
                        type='text'
                        defaultValue={user.firstName}
                        onChange={e => setFirstName(e.target.value)}
                    />
                </div>
                <div className='userInfoItem'>
                    <div className='userInfoLabel'>
                        {t.gettext('Last Name')}
                    </div>
                    <input
                        className='userInfoDetail'
                        type='text'
                        defaultValue={user.lastName}
                        onChange={e => setLastName(e.target.value)}
                    />
                </div>
                <div className='userInfoItem userInfoItem--disabled'>
                    <div className='userInfoLabel'>
                        {t.gettext('Email')}
                    </div>
                    <input
                        className='userInfoDetail'
                        type='email'
                        defaultValue={user.email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </div>
                {/*<NavLink exact to='/password_change'>*/}
                {/*    <div className='passwordChangeButtonHolder'>*/}
                {/*        <button className='passwordChangeButton'>*/}
                {/*            {t.gettext('Change Password')}*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*</NavLink>*/}
                {/*{userModules?.find(x => x.moduleType === 'GREENCLOUD_VIEW') && (*/}
                {/*    <label className="green-checkbox-label">*/}
                {/*        <input*/}
                {/*            type="checkbox"*/}
                {/*            checked={userModules?.find(x => x.moduleType === 'GREENCLOUD_VIEW')?.moduleActivated}*/}
                {/*            onChange={() => handleCheckboxChange(userModules?.find(x => x.moduleType === 'GREENCLOUD_VIEW'))}*/}
                {/*            className="green-checkbox"*/}
                {/*        />*/}
                {/*        <span className="custom-checkmark" />*/}
                {/*        {t.gettext('Greencloud Module')}*/}
                {/*    </label>*/}
                {/*)}*/}
                <div className='saveButtonHolder'>
                    <button
                        className='saveButton'
                        onClick={updateUserProfile}
                    >
                        {t.gettext('Save')}
                    </button>
                </div>
            </div>
        );
    }
};

export default UserDetailsForm;
